import { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { useAtomValue } from "jotai/utils";

import FilterTagGroup from "./filter-tag-group";
import { searchResultsAtom, searchFilterAtom } from "../../hooks/useSearch";
import sumObjectValuesByKey from "../../utils/sumObjectValuesByKey";

function ResultsFilter({
  showFilters = ["concepts.subject", "type", "educationalLevels"],
  onChange,
  ...restProps
}) {
  const searchFilter = useAtomValue(searchFilterAtom);
  const searchResults = useAtomValue(searchResultsAtom);
  const [filters, setFilters] = useState(searchFilter);

  const subjectFilters = showFilters.includes("concepts.subject")
    ? sumObjectValuesByKey(
        searchResults.results.courses.facetDistribution?.["concepts.subject"],
        searchResults.results.textbooks.facetDistribution?.["concepts.subject"],
        searchResults.results.learningResources.facetDistribution?.[
          "concepts.subject"
        ],
      )
    : null;

  const typeFilters = showFilters.includes("type")
    ? sumObjectValuesByKey(
        searchResults.results.courses.facetDistribution?.["type.name"],
        searchResults.results.textbooks.facetDistribution?.["type.name"],
        searchResults.results.learningResources.facetDistribution?.[
          "type.name"
        ],
      )
    : null;

  const levelFilters = showFilters.includes("educationalLevels")
    ? sumObjectValuesByKey(
        searchResults.results.courses.facetDistribution?.[
          "concepts.educational-level"
        ],
        searchResults.results.textbooks.facetDistribution?.[
          "concepts.educational-level"
        ],
        searchResults.results.learningResources.facetDistribution?.[
          "concepts.educational-level"
        ],
      )
    : null;

  const onChangeFilterGroup = (name, selectedFilters) => {
    const current = { ...filters };
    current[name] = selectedFilters;
    setFilters(current);

    if (onChange) onChange(current);
  };

  useEffect(() => {
    setFilters(searchFilter);
  }, [searchFilter]);

  return (
    <Row gutter={12} justify="center">
      {subjectFilters && (
        <Col xs={24} md={8} xl={6}>
          <FilterTagGroup
            key="subjects"
            name="concepts.subject"
            label="Subjects"
            values={filters["concepts.subject"]}
            filters={Object.entries(subjectFilters).sort((f, s) => s[1] - f[1])}
            onChange={onChangeFilterGroup}
          />
        </Col>
      )}
      {typeFilters && (
        <Col xs={24} md={8} xl={6}>
          <FilterTagGroup
            key="type"
            name="type.name"
            label="Material Type"
            values={filters["type.name"]}
            filters={Object.entries(typeFilters).sort((f, s) => s[1] - f[1])}
            onChange={onChangeFilterGroup}
          />
        </Col>
      )}
      {levelFilters && (
        <Col xs={24} md={8} xl={6}>
          <FilterTagGroup
            key="educationalLevels"
            name="concepts.educational-level"
            label="Level"
            values={filters["concepts.educational-level"]}
            filters={Object.entries(levelFilters).sort((f, s) => s[1] - f[1])}
            onChange={onChangeFilterGroup}
          />
        </Col>
      )}
    </Row>
  );
}

export default ResultsFilter;
